import {AgentHierarchy} from 'Agent/AgentInformation/models/AgentHierarchy';
import {Async, Empty, fromResult} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {AgencyFilters} from 'Shared/models/AgencyFilters';

export enum HierarchyActionType {
  GET_HIERARCHY_BY_AGENT_NUMBER = 'hiearchy/GET_HIERARCHY_BY_AGENT_NUMBER',
  GET_HIERARCHY = 'hiearchy/GET_HIERARCHY',
  LOAD_AGENT_HIERARCHY = 'hiearchy/LOAD_AGENT_HIERARCHY',
  CHANGE_HIERARCHY = 'hiearchy/CHANGE_HIERARCHY',
}

export const getHierarchy = (agentNumbers: string[], isNewYork: string, encryptedIdentifier: string) =>
  createAction(HierarchyActionType.GET_HIERARCHY, {
    encryptedIdentifier,
    agentNumbers,
    isNewYork,
  });
export const getHierarchyByAgentNumber = (agencyFilters: AgencyFilters, agentNumber: string) =>
  createAction(HierarchyActionType.GET_HIERARCHY_BY_AGENT_NUMBER, {agentNumber, agencyFilters});
export const changeHierarchy = (hierarchy: Async<AgentHierarchy>) =>
  createAction(HierarchyActionType.CHANGE_HIERARCHY, {hierarchy});
export const loadHierarchy = (hierarchy: AgentHierarchy) =>
  createAction(HierarchyActionType.LOAD_AGENT_HIERARCHY, {hierarchy});

type HierarchyState = Async<AgentHierarchy>;

const DEFAULT_STATE: HierarchyState = new Empty();

type HierarchyAction = ReturnType<typeof loadHierarchy> | ReturnType<typeof changeHierarchy>;

export default (state: HierarchyState = DEFAULT_STATE, action: HierarchyAction): HierarchyState => {
  switch (action.type) {
    case HierarchyActionType.CHANGE_HIERARCHY:
      return action.payload.hierarchy;
    case HierarchyActionType.LOAD_AGENT_HIERARCHY:
      return fromResult(action.payload.hierarchy);
    default:
      return state;
  }
};
